(() => {
  if (window.__PK9_LAUNCH_LOCK) return;
  window.__PK9_LAUNCH_LOCK = true;

  const config = window.PK9_LAUNCH_LOCK || {};
  const DEFAULT_UNLOCK_AT = Date.parse(config.unlockAt || '2026-09-01T00:00:00+02:00');
  const SEPTEMBER_UNLOCK_AT = Date.parse(config.septemberUnlockAt || '2026-09-01T00:00:00+02:00');
  const now = Date.now();

  if (
    (Number.isNaN(DEFAULT_UNLOCK_AT) || now >= DEFAULT_UNLOCK_AT) &&
    (Number.isNaN(SEPTEMBER_UNLOCK_AT) || now >= SEPTEMBER_UNLOCK_AT)
  ) return;

  const currentCollection = String(config.currentCollection || '').toLowerCase();
  if (currentCollection === 'testeurs-pk9') return;

  document.documentElement.classList.add('pk9-launch-prelaunch');

  const toHandleSet = (values) => new Set(
    Array.isArray(values)
      ? values.map((value) => String(value || '').toLowerCase()).filter(Boolean)
      : []
  );

  const LOCKED_HANDLES = toHandleSet(config.handles);
  const SEPTEMBER_HANDLES = toHandleSet(config.septemberHandles);
  const SEPTEMBER_COLLECTIONS = toHandleSet(
    config.septemberCollectionHandles || ['essential', 'future-division', 'grindeuse']
  );

  const IS_LAUNCH_COLLECTION = Boolean(
    config.collectionHandle &&
    currentCollection === String(config.collectionHandle).toLowerCase()
  );
  const IS_SEPTEMBER_COLLECTION = SEPTEMBER_COLLECTIONS.has(currentCollection);
  const IS_DELUXE_COLLECTION = currentCollection === 'deluxe';
  const CARD_SELECTOR = '.product-card, .pk9n-product, [data-product-card]';

  const handleFromHref = (href) => {
    if (!href) return '';
    try {
      const url = new URL(href, window.location.origin);
      const match = url.pathname.match(/\/products\/([^/?#]+)/i);
      return match ? decodeURIComponent(match[1]).toLowerCase() : '';
    } catch (_) {
      return '';
    }
  };

  const productHandle = (card) => {
    const ownHandle = card.dataset?.productHandle;
    if (ownHandle) return ownHandle.toLowerCase();
    const explicit = card.querySelector('[data-product-handle]')?.dataset.productHandle;
    if (explicit) return explicit.toLowerCase();
    const link = card.querySelector('a[href*="/products/"]');
    return handleFromHref(link?.getAttribute('href'));
  };

  const isDeluxeCard = (card) =>
    IS_DELUXE_COLLECTION ||
    card.classList.contains('product-card--deluxe') ||
    card.matches('[data-universe="deluxe"], [data-pk9-universe="deluxe"]');

  const releaseForCard = (card) => {
    const handle = productHandle(card);
    const isSeptemberRelease =
      IS_SEPTEMBER_COLLECTION ||
      Boolean(handle && SEPTEMBER_HANDLES.has(handle));

    if (isSeptemberRelease) {
      if (!Number.isNaN(SEPTEMBER_UNLOCK_AT) && Date.now() < SEPTEMBER_UNLOCK_AT) {
        return { target: SEPTEMBER_UNLOCK_AT, september: true, deluxe: false };
      }
      return null;
    }

    if (Number.isNaN(DEFAULT_UNLOCK_AT) || Date.now() >= DEFAULT_UNLOCK_AT) return null;

    const deluxe = isDeluxeCard(card);
    if (
      IS_LAUNCH_COLLECTION ||
      deluxe ||
      Boolean(handle && LOCKED_HANDLES.has(handle))
    ) {
      return { target: DEFAULT_UNLOCK_AT, september: false, deluxe };
    }
    return null;
  };

  const formatCountdown = (target) => {
    const remaining = Math.max(0, target - Date.now());
    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const pad = (value) => String(value).padStart(2, '0');
    return `${pad(days)}J · ${pad(hours)}H · ${pad(minutes)}M · ${pad(seconds)}S`;
  };

  let reloadScheduled = false;
  const refreshCountdowns = () => {
    let expired = false;
    document.querySelectorAll('[data-pk9-launch-countdown]').forEach((node) => {
      const target = Number(node.dataset.pk9LaunchTarget || 0);
      if (!target) return;
      node.textContent = formatCountdown(target);
      if (Date.now() >= target) expired = true;
    });
    if (expired && !reloadScheduled) {
      reloadScheduled = true;
      window.setTimeout(() => window.location.reload(), 500);
    }
  };

  const addVeil = (card, release) => {
    if (card.querySelector(':scope > .pk9-launch-lock__veil')) return;
    const dateLabel = release.september ? '01.09.2026 · 00:00' : '01.09.2026 · 00:00';
    const accessibleDate = release.september
      ? '1er septembre 2026 à minuit'
      : '1er septembre 2026 à minuit';
    const eyebrow = release.september
      ? 'OUVERTURE · 1ER SEPTEMBRE'
      : (release.deluxe ? 'DELUXE · RÉVÉLATION' : 'NOUVEAUTÉ 2027');

    const veil = document.createElement('div');
    veil.className = 'pk9-launch-lock__veil';
    veil.setAttribute('aria-label', `Produit révélé le ${accessibleDate}`);
    veil.innerHTML = `
      <span class="pk9-launch-lock__eyebrow">${eyebrow}</span>
      <strong class="pk9-launch-lock__countdown" data-pk9-launch-countdown>${formatCountdown(release.target)}</strong>
      <small>${dateLabel}</small>
    `;
    const countdown = veil.querySelector('[data-pk9-launch-countdown]');
    if (countdown) countdown.dataset.pk9LaunchTarget = String(release.target);
    card.appendChild(veil);
  };

  const lockCard = (card) => {
    if (!(card instanceof Element)) return;
    const release = releaseForCard(card);
    if (!release) return;

    const handle = productHandle(card);
    card.classList.add('pk9-launch-locked');
    card.dataset.pk9LaunchLocked = 'true';
    if (handle) card.dataset.pk9LaunchHandle = handle;

    card.querySelectorAll('a[href*="/products/"]').forEach((link) => {
      link.setAttribute('aria-disabled', 'true');
      link.setAttribute('tabindex', '-1');
    });

    card.querySelectorAll(
      '[data-pk9-quick-card], [data-pk9-quick-universal], .product-card__quick, .pk9n-product__quick'
    ).forEach((button) => {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.textContent = release.september ? 'Ouverture le 01.09' : 'Ouverture le 01.09';
    });

    addVeil(card, release);
  };

  const scan = (root = document) => {
    if (!(root instanceof Element) && root !== document) return;
    if (root instanceof Element && root.matches(CARD_SELECTOR)) lockCard(root);
    root.querySelectorAll?.(CARD_SELECTOR).forEach(lockCard);
  };

  const intercept = (event) => {
    const locked = event.target.closest?.('[data-pk9-launch-locked="true"]');
    if (!locked) return;
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    if (event.target.closest?.('a, button')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  };

  ['click', 'pointerdown', 'touchstart', 'keydown'].forEach((type) => {
    document.addEventListener(type, intercept, true);
  });

  const boot = () => {
    scan(document);
    refreshCountdowns();
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) scan(node);
      }));
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.setInterval(refreshCountdowns, 1000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();